__turbopack_context__.v({
  "collapseBtn": "Faq-module-scss-module__HkgeXG__collapseBtn",
  "faqBox": "Faq-module-scss-module__HkgeXG__faqBox",
  "faqDescription": "Faq-module-scss-module__HkgeXG__faqDescription",
  "faqTitle": "Faq-module-scss-module__HkgeXG__faqTitle",
  "heading": "Faq-module-scss-module__HkgeXG__heading",
  "main": "Faq-module-scss-module__HkgeXG__main",
  "subcontent": "Faq-module-scss-module__HkgeXG__subcontent",
  "viewAllFaq": "Faq-module-scss-module__HkgeXG__viewAllFaq",
});
